import { render, staticRenderFns } from "./PodDelivery.vue?vue&type=template&id=3a38d9e8"
import script from "./PodDelivery.vue?vue&type=script&lang=js"
export * from "./PodDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports